export class PagebuilderContactFormSubmission {
    name: string;
    senderEmail: string;
    recipientEmail: string;
    phone?: string;
    message: string;

    /* eslint-disable @typescript-eslint/no-explicit-any */
    constructor(map: Record<string, any>) {
        this.name = map.name?.trim() || "";
        this.senderEmail = map.senderEmail?.trim() || "";
        this.recipientEmail = map.recipientEmail?.trim() || "";
        this.phone = map.phone?.trim() || "";
        this.message = map.message?.trim() || "";
    }

    toMap(): Record<string, any> {
        const map: Record<string, any> = {};
        if (this.name) map.name = this.name;
        if (this.senderEmail) map.senderEmail = this.senderEmail;
        if (this.recipientEmail) map.recipientEmail = this.recipientEmail;
        if (this.phone) map.phone = this.phone;
        if (this.message) map.message = this.message;
        return map;
    }
    /* eslint-enable @typescript-eslint/no-explicit-any */
}